import { IntegrationType, IntegrationRequestType } from '@insights_module/types/Integrations';

export const INTEGRATION_QUERY_KEYS = {
  INFINITE_TAGS: 'infinite-integration-tags' as string,
  TAG_DETAILS: 'tag-details' as string,
};

export const INTEGRATION_TYPE = {
  MEGAPHONE: 'megaphone' as IntegrationType,
  IHM: 'ihm' as IntegrationType,
};

export const INTEGRATION_EPISODE_LIMIT = {
  [INTEGRATION_TYPE.MEGAPHONE]: 10000,
  [INTEGRATION_TYPE.IHM]: 100000,
};

export const INTEGRATION_TITLE_MAPPER = {
  [INTEGRATION_TYPE.IHM]: 'Triton',
  [INTEGRATION_TYPE.MEGAPHONE]: 'Megaphone',
};

export const INTEGRATION_TYPE_MAPPER = {
  // We are currently using the "starship-test" type for testing purposes and to avoid messing up the starship database.
  // When we are ready for production we need to change this type to "starship"
  [INTEGRATION_TYPE.IHM]: 'starship-test' as IntegrationRequestType,
  [INTEGRATION_TYPE.MEGAPHONE]: 'megaphone' as IntegrationRequestType,
};
